import type { CSSProperties } from 'react';

// Line-icon set ported from design_handoff_web/wa-icons.jsx. 1.6px strokes,
// round caps, 16×16 viewBox, inherits currentColor. One <Icon name> component.

const ICON_PATHS: Record<string, string> = {
  search: '<circle cx="7" cy="7" r="4.5"/><path d="M14 14l-3.6-3.6"/>',
  plus: '<path d="M8 2.5v11M2.5 8h11"/>',
  minus: '<path d="M2.5 8h11"/>',
  chevR: '<path d="M6 3l5 5-5 5"/>',
  chevL: '<path d="M10 3L5 8l5 5"/>',
  chevD: '<path d="M3 6l5 5 5-5"/>',
  chevU: '<path d="M3 10l5-5 5 5"/>',
  arrowR: '<path d="M3 8h10M9 4l4 4-4 4"/>',
  close: '<path d="M3.5 3.5l9 9M12.5 3.5l-9 9"/>',
  check: '<path d="M3 8.5l3.2 3.2L13 5"/>',
  heart: '<path d="M8 13.5S2.5 10 2.5 5.8A2.8 2.8 0 015.3 3c1.1 0 2.1.7 2.7 1.7C8.6 3.7 9.6 3 10.7 3a2.8 2.8 0 012.8 2.8C13.5 10 8 13.5 8 13.5z"/>',
  bookmark: '<path d="M4 2.5h8v11l-4-2.6-4 2.6z"/>',
  share: '<path d="M4 8v4.5a1 1 0 001 1h6a1 1 0 001-1V8M8 2v8M5 5l3-3 3 3"/>',
  pin: '<path d="M8 14.5C5 11 3 9 3 6.3A5 5 0 0113 6.3C13 9 11 11 8 14.5z"/><circle cx="8" cy="6.3" r="1.8"/>',
  calendar: '<rect x="2.5" y="3.5" width="11" height="10" rx="1.4"/><path d="M2.5 6.5h11M5.5 2v3M10.5 2v3"/>',
  clock: '<circle cx="8" cy="8" r="5.5"/><path d="M8 5v3.2l2.2 1.3"/>',
  star: '<path d="M8 2.2l1.7 3.7 4 .4-3 2.7.9 4L8 11l-3.5 2 .9-4-3-2.7 4-.4z"/>',
  users: '<circle cx="6" cy="6" r="2.3"/><path d="M2.5 13c0-2.2 1.6-3.6 3.5-3.6s3.5 1.4 3.5 3.6"/><path d="M10.5 4.2a2.2 2.2 0 010 4.1M11 13c0-1.8-.8-3-2-3.4"/>',
  filter: '<path d="M2.5 4h11M4.5 8h7M6.5 12h3"/>',
  grid: '<rect x="2.5" y="2.5" width="4.5" height="4.5" rx="1"/><rect x="9" y="2.5" width="4.5" height="4.5" rx="1"/><rect x="2.5" y="9" width="4.5" height="4.5" rx="1"/><rect x="9" y="9" width="4.5" height="4.5" rx="1"/>',
  list: '<path d="M5 4h9M5 8h9M5 12h9M2.5 4h.01M2.5 8h.01M2.5 12h.01"/>',
  sliders: '<path d="M3 5h6M11 5h2M3 11h2M7 11h6"/><circle cx="10" cy="5" r="1.4"/><circle cx="6" cy="11" r="1.4"/>',
  flight: '<path d="M2.5 9.5l11-3.2c.7-.2.7-1.2 0-1.4-.4-.1-.8 0-1.1.2L9.6 7 5 6 4 6.6l3 1.8-2 1.4-1.7-.3-.7.5 1.6 1.1.6 1.7.6-.3.2-1.7 1.6-1z"/>',
  train: '<rect x="3.5" y="2.5" width="9" height="9" rx="2"/><path d="M3.5 7h9M6 13l-1.2 1.3M10 13l1.2 1.3"/><circle cx="6" cy="9.3" r=".6"/><circle cx="10" cy="9.3" r=".6"/>',
  car: '<path d="M2.5 10.5v-1.8l1.3-3a1.5 1.5 0 011.4-.9h5.6a1.5 1.5 0 011.4.9l1.3 3v1.8M2.5 8.7h11"/><circle cx="5" cy="10.7" r="1.1"/><circle cx="11" cy="10.7" r="1.1"/>',
  bed: '<path d="M2.5 4v8M2.5 7.5h11a0 0 0 010 0v4M13.5 11.5v-4a2 2 0 00-2-2H6.5v3.5"/>',
  fork: '<path d="M5 2v5a1.5 1.5 0 01-3 0V2M3.5 7v7M11 2c-1.4 0-2.2 1.4-2.2 3.2 0 1.4.8 2.3 2.2 2.5V14"/>',
  ticket: '<path d="M2.5 5.5a1.5 1.5 0 011.5-1.5h8a1.5 1.5 0 011.5 1.5 1.5 1.5 0 000 3 1.5 1.5 0 01-1.5 1.5h-8A1.5 1.5 0 012.5 8.5a1.5 1.5 0 000-3z"/><path d="M9.5 4v8" stroke-dasharray="1.2 1.2"/>',
  sparkle: '<path d="M8 2.5l1.2 3.3L12.5 7 9.2 8.2 8 11.5 6.8 8.2 3.5 7l3.3-1.2z"/>',
  camera: '<rect x="2.5" y="5" width="11" height="8" rx="1.6"/><path d="M5.5 5l1-1.8h3l1 1.8"/><circle cx="8" cy="9" r="2.2"/>',
  yen: '<path d="M5 3.5l3 3.5 3-3.5M8 7v6.5M5.5 9h5M5.5 11h5"/>',
  edit: '<path d="M10.5 2.5l3 3L6 13l-3.5.8L3 10z"/>',
  trash: '<path d="M3 4.5h10M6 4.5V3h4v1.5M4.5 4.5l.6 8a1 1 0 001 1h3.8a1 1 0 001-1l.6-8"/>',
  kebab: '<circle cx="8" cy="3" r="1.1"/><circle cx="8" cy="8" r="1.1"/><circle cx="8" cy="13" r="1.1"/>',
  bell: '<path d="M8 2.5a3.8 3.8 0 00-3.8 3.8c0 3.4-1.2 4.4-1.2 4.4h10s-1.2-1-1.2-4.4A3.8 3.8 0 008 2.5zM6.5 13a1.6 1.6 0 003 0"/>',
  message: '<path d="M3.5 3h9A1.5 1.5 0 0114 4.5v5a1.5 1.5 0 01-1.5 1.5H7.5L4.5 13.5V11h-1A1.5 1.5 0 012 9.5v-5A1.5 1.5 0 013.5 3z"/>',
  external: '<path d="M6 3.5H4a1.5 1.5 0 00-1.5 1.5v6A1.5 1.5 0 004 12.5h6A1.5 1.5 0 0011.5 11V9M9 2.5h4v4M13 2.5L7 8.5"/>',
  compass: '<circle cx="8" cy="8" r="5.7"/><path d="M10.5 5.5L9 9l-3.5 1.5L7 7z"/>',
  home: '<path d="M2.8 7.5L8 3l5.2 4.5M4 6.7V13h8V6.7"/>',
  map: '<path d="M2.5 4.2L6 3l4 1.4 3.5-1.2v8.6L10 13l-4-1.4L2.5 12.8zM6 3v8.6M10 4.4V13"/>',
  dot: '<circle cx="8" cy="8" r="2.4" fill="currentColor" stroke="none"/>',
  phone: '<path d="M12.5 11c-1.2 1.7-3.4 1.7-5.2 0S4.5 7.2 4.5 7.2 5 5.5 6.7 5l1.3 2.2s-.6 1.7 0 2.3 2.3 0 2.3 0L12.5 11z"/>',
  external_link: '<path d="M6 3.5H4a1.5 1.5 0 00-1.5 1.5v6A1.5 1.5 0 004 12.5h6A1.5 1.5 0 0011.5 11V9M9 2.5h4v4M13 2.5L7 8.5"/>',
  check2: '<circle cx="8" cy="8" r="5.7"/><path d="M5.5 8.2l1.7 1.7L11 6"/>',
  info: '<circle cx="8" cy="8" r="5.7"/><path d="M8 7.3v3.4M8 5.2h.01"/>',
  lock: '<rect x="3.5" y="7" width="9" height="6" rx="1.4"/><path d="M5.5 7V5.3a2.5 2.5 0 015 0V7"/>',
  sun: '<circle cx="8" cy="8" r="2.8"/><path d="M8 1.8v1.7M8 12.5v1.7M1.8 8h1.7M12.5 8h1.7M3.6 3.6l1.2 1.2M11.2 11.2l1.2 1.2M12.4 3.6l-1.2 1.2M4.8 11.2l-1.2 1.2"/>',
  moon: '<path d="M13 9.2A5.4 5.4 0 116.8 3a4.2 4.2 0 006.2 6.2z"/>',
};

export type IconName = keyof typeof ICON_PATHS;

// kind → icon, for itinerary/booking rows
export const KIND_ICON: Record<string, string> = {
  flight: 'flight',
  rail: 'train',
  rental: 'car',
  hotel: 'bed',
  restaurant: 'fork',
  experience: 'sparkle',
  slot: 'ticket',
  shop: 'compass',
};

export default function Icon({
  name,
  size = 16,
  stroke = 1.6,
  style,
  className,
}: {
  name: string;
  size?: number;
  stroke?: number;
  style?: CSSProperties;
  className?: string;
}) {
  const p = ICON_PATHS[name] || ICON_PATHS.dot;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ flexShrink: 0, ...style }}
      dangerouslySetInnerHTML={{ __html: p }}
    />
  );
}
